import { FormControl } from '@angular/forms';
import _ from 'lodash';
import { CnsltnReqCrgoModel, QuotationService, TruckListModel, LgMessageModel, MessageService, LgMessageInfoModel, MessageModel, AlertService, ConsultRequestService, CnsltnReqModel, NewComment, CodeService, CodeSubModel, CnsltnType, UserService, UserModel} from '../../../../services/index';
import { REST_API_REQUEST_CALL_URL } from '../../../../utils/index';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MapsAPILoader } from '@agm/core';
import { FileUploader } from 'ng2-file-upload';
import { Router } from '@angular/router';
import * as SelectFX from 'periodicjs.component.selectfx';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import { Codes, Util, LclTotal } from '../../../../utils/index';
import bigdecimal from 'bigdecimal';
import { Subscription } from 'rxjs';
import { DataSelectorComponent } from 'app/components';
import { Utils } from 'ag-grid';
import { ApiService } from 'app/services/api.service';
declare var $:any;
declare var moment:any;
declare var google:any;


@Component({
	selector: 'container-consult-detail',
  templateUrl: 'consult-detail.html',
  styles: [`
    agm-map {
			height: 300px;
			width: 100%;
    }
  `],
})
export class ConsultdetailComponent implements OnInit {
  cnsltnReq = {
    crgoLst: [
      new CnsltnReqCrgoModel()
    ],
    quotNo:'',
    reqTp: '',
    stusCd: -1,
    reqNo: '',
    user: { firstNm:'', lastNm: ''},
    reqDtm: '',
    cnfrmDtm: '',
    orgTp: 0,
    orgCntryNm: '',
    orgAdrs: '',
    orgLatitude: 0,
    orgLongitude: 0,
    desTp: 0,
    desCntryNm: '',
    desAdrs: '',
    desLatitude: 0,
    desLongitude: 0,
    reqSrvcLst: [],
    other: '',
    modifyDtm: '',
    isImpossible : 0,
    cmpltYn: 0,
    remainderSecond: 0,
    transTp:''
  };

  cnsltnQuotLst: Array<any> = [];
  crncyRateLst: Array<any> = [{cntryCd: '', crncyCd: ''}];
  docLst: Array<any> = [];
  dgDocLst: Array<any> = [];
  cnsltnCmnt :ConsultComment = new ConsultComment();
  comment:NewComment = new NewComment();
  cnsltnCmntList: Array<ConsultComment>;
  cnsltnGuideCmntList: Array<ConsultComment>;

  statusCd: string = '';
  reqDtm: string = '';
  cnfrmDtm: string = '';
  pastDays: string = '';

  cargoList: Array<CnsltnReqCrgoModel> = [ new CnsltnReqCrgoModel() ];

  lat1: number;
  lng1: number;
  lat2: number;
  lng2: number;
  zoom1: number;
  zoom2: number;

  uploader: FileUploader = new FileUploader({
    allowedMimeType: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
    maxFileSize: 5*1024*1024 // 5 MB
  });
  picDocLst: Array<any> = [];
  cargoPicUrl: string = '';
  cargoPicDocId: string = '';

  isRf: boolean = false;
  isDg: boolean = false;

  crncy: string;
  crncyValue: number = 0;
  smallestCost: number = 0;

  bookedQuot;
  cnsltnBook;
  cnsltnShpnadv;
  cnsltnCntrLst;

  lclPkgUnit: Function = Codes.lclPkgUnit;  
  dateFomatter:Function = Util.dateFomatter;
  timeFomatter:Function = Util.timeFomatter;
  hsCodeSplit:Function = Codes.hsCodeSplit;
  currencyFormat:Function = Util.currencyFormat;
  checkTempUnit: Function = Codes.checkTempUnit;
  getEndCount: Function = Util.getEndCount;
  
  cnsltnTruckLst: Array<TruckListModel>;

  reqNo:string;
  cnsltnMessage: Array<LgMessageModel> = new Array<LgMessageModel>();  
  otherCargoList;

  commentControl: FormControl = new FormControl();

  fileTooltipShow:boolean = false;

  modifyDtm;

  copying: boolean = false;
  isOpenImpsbRsnModal: boolean = false;
  impsbRsnCdList:Array<any> = new Array<any>();
  cnsltnReqImpsbRsn:CnsltnReqModel = new CnsltnReqModel();

  lclCnt: number = 0;
  lclTotalCbm: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalWeight: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalGW: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalCW: bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  lclTotalRTCbm : bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
  showGwMethod: boolean = true;
  
  subscription: Subscription ;
  saveCmnt:boolean = false;

  showComment:boolean = false;
  selectedCmnt:ConsultComment;
  showWriteComment: boolean = true;
  editCmnt: boolean = false;

  mapWidth;

  closeDtmTimer = null;
  isApiCalling:boolean = false;

  showFwdrs = false;

  isOpenChangeUserModal = false;
  wdhRequired = false;

  userList:Array<UserModel> = new Array();
  selectedUser:UserModel = null;

  @ViewChild("userSelector")
  userSelector: DataSelectorComponent;
  
  constructor(
    private consultRequestService:ConsultRequestService,
    private quotationService: QuotationService,
    private route: ActivatedRoute,
    private mapsAPILoader: MapsAPILoader,
    private router: Router,
    private messageService: MessageService,
    private alertService: AlertService,
    private codeService:CodeService,
    private userService:UserService,
    private apiService : ApiService
  ) {
  }

  ngOnInit(): void {
    this.initImpsbRsnCdList();
    this.getConsultDetail();  
    this.zoom1 = 12;
    this.zoom2 = 12;

    let mapWidth = $('.port-start').width();
    this.mapWidth = Math.ceil(mapWidth);
  }
  
  initImpsbRsnCdList(){
    this.codeService.getCodeListByCodeId(1).subscribe(resp => {
      if(resp.result && resp.data){
        resp.data.forEach((code:CodeSubModel) => {
          this.impsbRsnCdList.push({id:code.cdSeq, text:code.cdNm});
        });
      }
    });
  }

  getConsultDetail() {
    this.route.paramMap
    .switchMap((params: ParamMap) => this.quotationService.getConsultReport(params.get('id')))
    .subscribe(
      (resp:any) => {
        const data = this.checkAdrsText(resp.data);
        this.requestSeparation(data);
      },
      error => {console.log(error)},
      () => console.log('done')
    );
  }

  checkAdrsText(data) {
    const desAdrs = data.cnsltnReq.desAdrs;
    const orgAdrs = data.cnsltnReq.orgAdrs;
    const appendText = data.cnsltnReq.transTp === 0 ? '[Port]' : '[Airport]';

    if(data.cnsltnReq.desTp === 0 && !desAdrs.includes(appendText)) {
      data.cnsltnReq.desAdrs = `${appendText} ${desAdrs}`;
    }

    if(data.cnsltnReq.orgTp === 0 && !orgAdrs.includes(appendText)) {
      data.cnsltnReq.orgAdrs = `${appendText} ${orgAdrs}`;
    }
  
    return data;
  }

  docListChanged() {
    this.getConsultDetail();
  }

  requestSeparation(consult) {
    
    this.cnsltnReq = consult.cnsltnReq;
    this.crncyRateLst = consult.crncyRateLst;
    this.cnsltnQuotLst = consult.cnsltnQuotLst;
    this.cargoList = this.cnsltnReq.crgoLst;
    this.docLst = consult.docLst;
    // this.cnsltnCmnt = consult.cnsltnCmnt;

    if(consult.cnsltnCmntList && consult.cnsltnCmntList.length > 0){
      this.cnsltnCmntList = consult.cnsltnCmntList.filter(cmnt => cmnt.cmntType != 0 );
      this.cnsltnGuideCmntList = consult.cnsltnCmntList.filter(cmnt => cmnt.cmntType == 0 );
    }


    if(this.cargoList.some(list=>list.crgoTp == 'OT'|| list.crgoTp == 'FR')) {
      this.wdhRequired = true;
    } else {
      this.wdhRequired = false;
    }

    this.cnsltnBook = consult.cnsltnBook;
    this.cnsltnTruckLst = consult.cnsltnTruckLst;
    this.cnsltnCntrLst = consult.cnsltnCntrLst;
    this.cnsltnShpnadv = consult.cnsltnShpnadv;
      
    
    if(this.cnsltnReq.other != null && this.isJson(this.cnsltnReq.other)) {
      this.otherCargoList = JSON.parse(this.cnsltnReq.other);
    }

    if(this.cargoList != null){
      this.cargoList.map((crgo:CnsltnReqCrgoModel) => {
        let height = new bigdecimal.BigDecimal("0");
        let width = new bigdecimal.BigDecimal("0");
        let length = new bigdecimal.BigDecimal("0");
        let weight = new bigdecimal.BigDecimal("0");
        let count = new bigdecimal.BigDecimal("0");
        let cw = new bigdecimal.BigDecimal("0");
        let cbm = new bigdecimal.BigDecimal("0");

        if(crgo.height) height = new bigdecimal.BigDecimal(crgo.height);
        if(crgo.width) width = new bigdecimal.BigDecimal(crgo.width);
        if(crgo.length) length = new bigdecimal.BigDecimal(crgo.length);
        if(crgo.weight) weight = new bigdecimal.BigDecimal(crgo.weight);
        if(crgo.count) count = new bigdecimal.BigDecimal(crgo.count);
        if(crgo.cbm) cbm = new bigdecimal.BigDecimal(crgo.cbm);

        cw = height.multiply(width.multiply(length));
        cw = cw.divide(new bigdecimal.BigDecimal('0.006'), 25, bigdecimal.RoundingMode.HALF_UP());
        cw = cw.multiply(count);
        weight = weight.multiply(count);
        if(weight.compareTo(cw) == 1){
          cw = weight;
        }
        crgo.cw = cw.setScale(2, bigdecimal.RoundingMode.HALF_UP()).doubleValue();
        // 2021-06-29 cbm 표기 오류 수정 bigdecimal.RoundingMode.UP => bigdecimal.RoundingMode.HALF_UP으로 수정
        crgo.cbm = cbm.multiply(count).setScale(2, bigdecimal.RoundingMode.HALF_UP()).doubleValue();
      });
    }

    if(this.cargoList[0].rfYn == 1) this.isRf = true; 
    if(this.cargoList[0].dgYn == 1) this.isDg = true;

    
    // if(this.cnsltnCmnt != null && this.cnsltnCmnt.cmnt != null) this.commentControl.setValue(this.cnsltnCmnt.cmnt);

    this.getCnsltnMessage();

    this.getStatusCd(this.cnsltnReq.stusCd);

    this.reqDtm = this.getLocalDtmStr(this.cnsltnReq.reqDtm);
    
    if(!_.isEmpty(this.cnsltnReq.cnfrmDtm)) {
      let cnfrmDtm = this.getLocalDtmStr(this.cnsltnReq.cnfrmDtm);
      this.cnfrmDtm = cnfrmDtm.substr(2);
      this.pastDays = this.getPastDaysAndHours(cnfrmDtm);
    }
    
    if(this.cargoList[0].crgoTp == 'RF') this.isRf = true; 
    if(this.cargoList[0].crgoTp == 'DG') this.isDg = true;

    
    if(this.cnsltnReq.orgLatitude != null && this.cnsltnReq.orgLongitude != null) {
      this.lat1 = this.cnsltnReq.orgLatitude;
      this.lng1 = this.cnsltnReq.orgLongitude;
    } else {
      if(this.cnsltnReq.orgTp === 0) {
        this.getLatLng(this.cnsltnReq.orgAdrs, this.cnsltnReq.orgCntryNm, 'org')
      } else {
        this.getLatLng(this.cnsltnReq.orgCntryNm, null, 'org')
      }
    }

    if(this.cnsltnReq.desLatitude != null && this.cnsltnReq.desLongitude != null) {
      this.lat2 = this.cnsltnReq.desLatitude;
      this.lng2 = this.cnsltnReq.desLongitude;
    } else {
      if(this.cnsltnReq.desTp === 0) {
        this.getLatLng(this.cnsltnReq.desAdrs, this.cnsltnReq.desCntryNm, 'des')
      } else {
        this.getLatLng(this.cnsltnReq.desCntryNm, null, 'des')
      }
    }

    this.dgDocLst = [];
    for(let i=0; i< this.docLst.length; i++) {
      if(this.docLst[i].docNm == 'MSDS' && !this.docLst[i].corpId) this.dgDocLst.push(this.docLst[i]);
    }

    if(this.docLst != null) this.cargoPicFiles(this.docLst);
    if(this.cnsltnQuotLst != null) this.minCost();
    if(this.cnsltnReq.quotNo != null) this.bookedQuot = _.find(this.cnsltnQuotLst, {quotNo: this.cnsltnReq.quotNo });
    if(this.cnsltnReq.modifyDtm != null) { 
      let modifyDtm = moment(this.cnsltnReq.modifyDtm, 'YYYY/MM/DD HH:mm:ss').add(9, 'hours');
      this.modifyDtm = modifyDtm.format('YYYY/MM/DD HH:mm:ss');
    }
    this.calcLclMeasurement();

    if(this.cnsltnReq.remainderSecond){
    

      if(this.closeDtmTimer){
        clearInterval(this.closeDtmTimer);
      }

      this.closeDtmTimer = setInterval(()=> {
        this.cnsltnReq.remainderSecond -= 1; 
        if(this.cnsltnReq.remainderSecond < 0) {
          clearInterval(this.closeDtmTimer);
        }
      },1000);   

    }
  }

  getCnsltnMessage(){
    let reqNo = this.cnsltnReq.reqNo
    this.messageService.getConsultMessageInfo(reqNo).subscribe(
			resp => {
				if(resp.result){
					let lgMessageList:Array<LgMessageModel> = resp.data.lgMessageList;
          this.cnsltnMessage = lgMessageList;
				}
			},
			error => {console.log(error)}
    );  
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  getStatusCd(stusCd) {
    switch(stusCd) {
      case -1:
        this.statusCd = 'step1';
        break;
      case 0:
        this.statusCd = 'step1';
        break;
      case 1:
        this.statusCd = 'step1';
        break;
      case 2:
        this.statusCd = 'step2';
        break;
      case 3:
        this.statusCd = 'step3';
        break;
      case 4:
        this.statusCd = 'step4';
        break;
      case 5:
        this.statusCd = 'step5';
        break;
      default:
        this.statusCd = 'step1';
    } 
  }

  getLocalDtmStr(dtm:string):string {
		return moment(dtm, "YYYY/MM/DD HH:mm").add(9, 'hour').format('YYYY/MM/DD HH:mm:ss');
  }
  
  getPastDaysAndHours(cnfrmDtm) {
    var diff = moment.duration(moment(cnfrmDtm, 'YYYY/MM/DD HH:mm:ss').diff(moment()));
    var days = parseInt(diff.asDays());
    var hours = parseInt(diff.asHours());
    hours = -(hours - days*24);  // 23 hours
    return days + 'd ' + hours + 'h';
  }

  getOrgLatLng(latlng) {
    this.lat1 = _.nth(latlng, 0);
    this.lng1 = _.nth(latlng, 1);
    this.zoom1 = 7;
  }

  getDesLatLng(latlng) {
    this.lat2 = _.nth(latlng, 0);
    this.lng2 = _.nth(latlng, 1);
    this.zoom2 = 7;
  }  

  getLatLng(adrs, cntryNm, orgOrDes) {
    let latlng = [];
    let that = this;
    this.mapsAPILoader.load().then(() => {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode( { 'address' : adrs }, function( results, status ) {
          if( status == google.maps.GeocoderStatus.OK ) {
            latlng.push(results[0].geometry.location.lat()),
            latlng.push(results[0].geometry.location.lng())
            if(orgOrDes == 'org') {
              that.getOrgLatLng(latlng);
            } else {
              that.getDesLatLng(latlng);
            }
          } else {
            console.log( 'Geocode was not successful for the following reason: ' + status );
            geocoder.geocode( { 'address' : cntryNm }, function( results, status ) {
              if( status == google.maps.GeocoderStatus.OK ) {
                latlng.push(results[0].geometry.location.lat()),
                latlng.push(results[0].geometry.location.lng())
                if(orgOrDes == 'org') {
                  that.getOrgLatLng(latlng);
                } else {
                  that.getDesLatLng(latlng);
                }
              } else {
                console.log( 'Geocode was not successful for the following reason: ' + status );
              }
            });
          }
        });
      });
  }

  hasService(srvcCd) {
		if (_.includes(this.cnsltnReq.reqSrvcLst, srvcCd)) return true;
		else return false;
  }

  cargoPicFiles(docLst) {
    this.picDocLst = [];

    this.apiService.getToken(res => {
      const access_token = sessionStorage.getItem('_vcd');
      if (access_token) {
        for(let i=0; i<docLst.length; i++) {
          if(docLst[i].docNm == 'cargoPic'){
            docLst[i].url = REST_API_REQUEST_CALL_URL.BASE_URL + 'consult/document?reqno=' + this.cnsltnReq.reqNo + '&docId=' + docLst[i].docId + '&token=' + access_token;
            this.picDocLst.push(docLst[i]);
          }
        }
      }
    });
  }

  getDocUrl(docId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.apiService.getToken(res => {
        const access_token = sessionStorage.getItem('_vcd');
        resolve(REST_API_REQUEST_CALL_URL.BASE_URL + 'consult/document?reqno=' + this.cnsltnReq.reqNo + '&docId=' + docId + '&token=' + access_token);
      });
    });
  }

  msdsFileDownload(msdsFile:any){
    this.apiService.getToken(res => {
      const access_token = sessionStorage.getItem('_vcd');
      if (access_token) {
        let url = REST_API_REQUEST_CALL_URL.BASE_URL + 'consult/document?reqno=' + this.cnsltnReq.reqNo + '&docId=' + msdsFile.storedFileNm + '&token=' + access_token;
        var link = document.createElement("a");
        link.download = url;
        link.href = url;
        link.click();
      }
    });
  }

  uploadPicFile(fileInput: any) {
    if(this.picDocLst.length < 4) {
      this.quotationService.postCargoPics(this.uploader, this.cnsltnReq.reqNo);
      this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
        var responsePath = JSON.parse(response);
        this.cargoPicFiles(responsePath.data);
        this.getCnsltnMessage();
      };
    }
    if(this.picDocLst.length == 4) {
      this.alertError('화물사진은 4개까지 업로드 할 수 있습니다.');
    }
  }

  deletePicFile(doc, index) {
    Util.confirm(
      doc.fileNm + '파일을 삭제하시겠습니까?',
      () => {
        let body = { docId : doc.docId };
        this.picDocLst.splice(index, 1);
        this.quotationService.delCargoPics(this.cnsltnReq.reqNo, doc.docId).subscribe(
          resp => {
            if(resp.result){
              this.cargoPicFiles(resp.data);
              this.getCnsltnMessage();
            }
          }
        );
      },
      () => {}
    );
  }

  showCargoPicLarge(pic): void {
    this.getDocUrl(pic.docId).then(url => {
      this.cargoPicDocId = pic.docId;
      this.cargoPicUrl = url;
      this.modal();
    })
  }

  hideCargoPicLarge() {
    this.modal();
  }

  modal() {
		if($('.cargopic-check-modal .sweet-modal-overlay').hasClass('open')) {
			$('.cargopic-check-modal .sweet-modal-overlay').removeClass('open');
		} else {
			$('.cargopic-check-modal .sweet-modal-overlay').addClass('open');
		}		
  }

  booking() {
    this.getConsultDetail();
  }

  // saveComment() {
  //   this.quotationService.postComment(this.cnsltnReq.reqNo, this.commentControl.value).subscribe(
  //     resp => {
  //       if(resp.result) {
  //         this.alertService.success("안내사항이 저장되었습니다.");
  //       } else {
  //         this.alertService.success("오류가 발생했습니다. 다시 시도해 주세요.");
  //       }
  //     }
  //   );
  // }

  quotationRegister(){
    this.router.navigate(['/quotation/fare-detail', this.cnsltnReq.reqNo]);
  }

  minCost() {
    this.crncy = this.crncyRateLst[this.crncyValue].crncyCd;
    let quot = this.cnsltnQuotLst;
    let ttCost = [];
      
    for (var i=0 ; i < quot.length; i++) {
      if(!quot[i].summary) return ;
      for (var k=0; k < quot[i].summary.totalCost.length; k++) {
        if(this.crncyValue == k) {
          ttCost.push(quot[i].summary.totalCost[k]);
        }
      }
    }

    let small = Math.min(...ttCost);
    this.smallestCost = small;
  }

  showTooltip() {
    this.fileTooltipShow = true;
  }

  hideTooltip() {
    this.fileTooltipShow = false;
  }

  alertError(msg: string) {
		$.sweetModal({
			content: msg,
			icon: $.sweetModal.ICON_WARNING,
		});
  }
  
  moveCnsltnList(){
		this.router.navigate(['quotation/consult-list']);
  }

  editConsultRequest() {
    this.copying = false;
    this.consultRequestService.copyConsultRequest(this.copying);
    let that = this;
    $.sweetModal.confirm('견적을 수정하시겠습니까?', function() {
      if(that.cnsltnReq.stusCd >= 2) {
        $.sweetModal.confirm('견적 수정시 부킹이 취소됩니다.', function() {
          that.quotationService.cancelBooking(that.cnsltnReq.reqNo)
          .subscribe(
            resp => {
              if (resp.result) {
                that.router.navigate(['/quotation/consult', that.cnsltnReq.reqNo]);
              } else {
                $.sweetModal({
                  content: "부킹취소 실패",
                  icon: $.sweetModal.ICON_WARNING,
                });
              }          
            }
          );
        }, function() {
        });
      } else {
        that.router.navigate(['/quotation/consult', that.cnsltnReq.reqNo]);
      }
    }, function() {
    }); 
  }

  downImg() {
    this.getDocUrl(this.cargoPicDocId).then(url => {
      var link = document.createElement("a");
      link.download = url;
      link.href = url;
      link.click();
    });
  }

  deleteConsultRequest() {
    let that = this;
    $.sweetModal.confirm('견적을 삭제하시겠습니까?', function() {
      that.consultRequestService.deleteConsult(that.cnsltnReq.reqNo).subscribe(
        resp => {
          if(resp.result) {
            $.sweetModal('견적이 삭제되었습니다.');
            that.router.navigate(['quotation', 'consult-list']);
          } else {
            $.sweetModal('에러가 발생했습니다. 다시 시도해 주세요.');
          }
        }
      );
    }, function() {
    });
  }
  
  impossibleConsult(){
    if(this.cnsltnReqImpsbRsn.impsbRsnCd == 99 && this.cnsltnReqImpsbRsn.impsbRsnDscrt.replace("기타사유 :","").length < 1){
      $.sweetModal('기타사유를 등록해주세요');
      return ;
    }
    this.cnsltnReqImpsbRsn.reqNo = this.cnsltnReq.reqNo;
    this.cnsltnReqImpsbRsn.isImpossible = 1;
    this.consultRequestService.updateIsImpossibleConsult(this.cnsltnReqImpsbRsn).subscribe(
      resp => {
        this.isOpenImpsbRsnModal = false;

        if(resp.result) {
          this.cnsltnReq.isImpossible = 1;
          this.cnsltnReqImpsbRsn = new CnsltnReqModel();
          $.sweetModal('견적이 불가능으로 처리 되었습니다.');
        } else {
          $.sweetModal('에러가 발생했습니다. 다시 시도해 주세요.');
        }
      }
    );
  }

  possibleConsult(){
    let that = this;
    $.sweetModal.confirm('견적을 가능으로 처리하시겠습니까?', function() {
      that.cnsltnReq.isImpossible = 0;
      that.cnsltnReqImpsbRsn.isImpossible = 0;
      that.cnsltnReqImpsbRsn.reqNo = that.cnsltnReq.reqNo;
      that.cnsltnReqImpsbRsn.impsbRsnCd = null;
      that.cnsltnReqImpsbRsn.impsbRsnDscrt = null;

      that.consultRequestService.updateIsImpossibleConsult(that.cnsltnReqImpsbRsn).subscribe(
        resp => {
          if(resp.result) {
            $.sweetModal('견적이 가능으로 처리 되었습니다.');
          } else {
            $.sweetModal('에러가 발생했습니다. 다시 시도해 주세요.');
          }
        }
      );
    }, function() {
    });
  }

  impossibleModalOpen() {
    this.isOpenImpsbRsnModal = !this.isOpenImpsbRsnModal;
  }

  selectImpsbRsnCd(value:any, index:number):void {
    this.cnsltnReqImpsbRsn.impsbRsnCd = value.id;
    this.cnsltnReqImpsbRsn.impsbRsnDscrt = value.text;
    if(value.id == 99){
      this.cnsltnReqImpsbRsn.impsbRsnDscrt = "기타사유 :";
    }
  }

  selectChangeUser(value:any, index:number){

  }

  setImpsbRsnText($event){
    this.cnsltnReqImpsbRsn.impsbRsnDscrt = $event.target.value;
  }

  closeImpsbRsnModal(){
    this.isOpenImpsbRsnModal = false; 
    this.cnsltnReqImpsbRsn = new CnsltnReqModel();
  }

  reReqeustCnsltnReqEmail(){

    let that = this;
    $.sweetModal.confirm('이메일을 재발송 하시겠습니까?', function() {
      that.consultRequestService.reReqeustCnsltnReqEmail(that.cnsltnReq.reqNo).subscribe(
        resp => {
          if(resp.result) {
            that.alertService.success("이메일이 재발송 되었습니다.");
          }else{
            that.alertService.success("이메일이 재발송이 실패 되었습니다.");
          }
        }
      );
    }, function() {
    });
  }
  
  calcLclMeasurement() {
		Util.calcLclTotal(this.cargoList, (lclToal: LclTotal) => {
      this.lclCnt = lclToal.lclCnt;
      this.lclTotalCbm = lclToal.lclTotalCbm;
      this.lclTotalRTCbm = lclToal.lclTotalRTCbm
      this.lclTotalWeight = lclToal.lclTotalWeight
      this.lclTotalCW = lclToal.lclTotalCW;
    });
  }
  


  completeRequest() {
    this.consultRequestService.completeCnsltnReq(this.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            this.cnsltnReq.cmpltYn = 1;
          } else {
            $.sweetModal({
              content: "처리 실패",
              icon: $.sweetModal.ICON_WARNING,
            });
          }
        }
      );
    
    
  }

  completeCancelRequest() {
    this.consultRequestService.completeCancelCnsltnReq(this.cnsltnReq.reqNo)
      .subscribe(
        resp => {
          if (resp.result) {
            this.cnsltnReq.cmpltYn = 0;
          } else {
            $.sweetModal({
              content: "처리 실패",
              icon: $.sweetModal.ICON_WARNING,
            });
          }
        }
      );
  }

  extendCloseEndDtm(){
    let that = this;
    $.sweetModal.confirm('마감을 연장 하시겠습니까?', function() {
      that.consultRequestService.extendCloseEndDtm(that.cnsltnReq.reqNo).subscribe(
        resp => {
          if(resp.result) {
            that.alertService.success("마감이 연장 되었습니다.");
            that.getConsultDetail();
          }else{
            that.alertService.error("마감 연장이 실패 되었습니다.(API 에러)");
          }
        }
      );
    }, function() {
    });
  }

  addComment(cmnt?) {

    if(cmnt) {
      this.comment.cmnt = cmnt.cmnt;
    }

    this.comment.quotNo = null;
    this.comment.reqNo = this.cnsltnReq.reqNo;
    this.comment.corpId = 150;
    this.comment.cmntType = 0;
    this.saveCmnt = true;
    this.quotationService.addComment(this.cnsltnReq.reqNo, this.comment).subscribe(
      resp => {
        if(resp.result) {
          this.comment.cmnt = null;
          if(resp.data && resp.data.length > 0){
            this.cnsltnCmntList = resp.data.filter(cmnt => cmnt.cmntType != 0 );
            this.cnsltnGuideCmntList = resp.data.filter(cmnt => cmnt.cmntType == 0 );
          }
          Util.alertSuccess("저장이 완료 되었습니다.");
        } else {
          Util.alertWarn(resp.errorMsg);
        }
        this.saveCmnt = false;
      },
      error => {
        Util.alertWarn('오류가 발생했습니다. 다시한번 시도 해 주세요.');        
      },
      () => {
        this.saveCmnt = false;
      }
    )
  }

  handleSelectComment(cmnt) {
    if(cmnt == this.selectedCmnt){
      this.selectedCmnt = null;
    }else{
      this.selectedCmnt = cmnt;
    }
    this.showWriteComment = false;
    this.editCmnt = false;
  }

  handleShowWrite() {
    if(this.showWriteComment) {
      this.showWriteComment = false;
    } else {
      this.selectedCmnt = null;
      this.showWriteComment = true;
    }
  }

  handleEditComment() {
    this.editCmnt = true;
  }

  isQuotRequestWait(stusCd:number):boolean{
    return stusCd == -2;   
  }

  getCurStusNm(stusCd:number):string{

    let name = "";

    if(stusCd == null) return name;  

    switch (stusCd) {
      case -2:
        name = "견적 요청 대기";
        break;
      case -1:
        name = "견적 요청";
        break;
      case 0:
        name = "확인 대기";
        break;
      case 1:
        name = "견적 참여";
        break;
      case 2:
        name = "부킹 승인 요청";
        break;
      case 3:
        name = "진행중";
        break;
      case 4:
        name = "도착 완료";
        break;
      case 5:
        name = "운송 완료";
        break;
      default:
        break;
    }

    return name;
  }

  doRequestToQuot(reqNo:string){

    if(!reqNo) this.alertService.error("컨설팅 요청(ReqNo) 번호가 존재 하지 않습니다.");

    let that = this;

    $.sweetModal.confirm('포워더에게 견적 요청을 하시겠습니까?', function() {

      that.isApiCalling = true;

      that.consultRequestService.doRequestToQuot(reqNo).subscribe(
        resp => {
          if(resp.result) {
            
            that.alertService.success("견적 요청이 완료 되었습니다.");
            that.getConsultDetail();
          }
          that.isApiCalling = false;
        }
      );
    }, function() {
    });
  }

  handleShowFwdrs() {
    if(this.showFwdrs) {
      this.showFwdrs = false;
    } else {
      this.showFwdrs = true;
    }
  }

  getCnsltnType(reqTp:number, transTp:number):CnsltnType{
    return this.consultRequestService.getCnsltnType(reqTp, transTp);
  } 

  openChangeCnsltnReqUserModel(){
    this.userService.getUserList('NOT_LEAVE').subscribe(res=>{
      if(res){
        this.userList = res.filter(user => user.jobTp == 0);
      }
    });
    this.isOpenChangeUserModal = true;
    this.selectedUser = null;
  }

  closeChangeCnsltnReqUserModel(){
    this.isOpenChangeUserModal = false;
    this.selectedUser = null;
    if(this.userSelector){
      this.userSelector.close();
    }
  }

  changeCnsltnReqUser(){

    if(!this.cnsltnReq || !this.selectedUser){
      Util.alertWarn("변경하기 위한 필수 값이 존재하지 않습니다.");
      return ;
    }

    Util.confirm("요청자를 변경하시겠습니까?", () => {
      this.consultRequestService.changeCnsltnOwner(this.cnsltnReq.reqNo, this.selectedUser.userId).subscribe( resp =>{
        if(resp.result){
          this.alertService.success("요청자 변경이 완료 되었습니다.");
          this.closeChangeCnsltnReqUserModel();
          this.getConsultDetail();
        }
      });
    }, () =>{});
  }

  selecedUser(user:UserModel){
    this.selectedUser = user;
  }

  replaceRow(cmnt: string) {
    return cmnt.replace(/\n/g, '<br/>');
  }
}

export class ConsultComment {
  cmnt:string;
  insDtm:number;
  insUsr:string;
  reqNo:string;
}



// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/consult-detail.ts